import appNavigation from './app-navigation';
import appModules from './app-modules';

// ============================================================================
// Navigation V2 — Module tabs + subGroup separators
//
// Ý tưởng đơn giản:
//   1. Mỗi item (kể cả nhóm con) được gán { module, subGroup } qua RULES.
//   2. Nếu không khớp RULES chính xác → fallback theo PREFIX_RULES (tiền tố path).
//   3. HIDDEN_PATHS: các item ẩn hẳn.
//   4. FLATTEN_ANCHORS: nhóm có path anchor nằm ở đây thì mở banh trẻ con
//      ra thành các item flat (mỗi trẻ con tự resolve module+subGroup).
//
// Muốn chuyển về tree-list (v1): AntMainLayout tự switch về AntNavigationMenu
// khi appModules = [] (hoặc xoá import appModules khỏi ./index.js).
// ============================================================================

// --- RULES: exact path → { module, subGroup? } ------------------------------
var RULES = {
    '/home': { module: 'home' },
    '/wf/WFApprovalPendings': { module: 'home' },
    '/wf/WFApprovalPolicys': { module: 'setting' },

    // MF — anchor thật (item đầu "Tổng quan") đã đổi từ /mf/MFDashboard sang /dashboard/manufacturing
    // (dashboard sản xuất chuyển vào Trang chủ) → không còn khớp PREFIX_RULES '/mf/' nữa, phải khai rõ ở
    // đây, nếu không cả nhóm "Sản xuất" rơi vào module mặc định 'setting' (mất hẳn khỏi tab của nó).
    '/dashboard/manufacturing': { module: 'mf' },

    // AR — sell
    '/ar/ARAppointments': { module: 'ar', subGroup: 'sell' },
    '/ar/AROrders': { module: 'ar', subGroup: 'sell' },
    '/ar/ARTradeIns': { module: 'ar', subGroup: 'sell' },
    '/ar/ARReturns': { module: 'ar', subGroup: 'sell' },
    '/rental/ARBookings': { module: 'ar', subGroup: 'sell' },
    '/rental/ARRentalRoomBookings': { module: 'ar', subGroup: 'sell' },
    '/rental/ARRentalVehicleBookings': { module: 'ar', subGroup: 'sell' },

    // AR — fulfill
    '/ar/ARServicePlans': { module: 'ar', subGroup: 'fulfill' },
    '/ar/ARIssues': { module: 'ar', subGroup: 'fulfill' },
    '/serve/ARServeServices': { module: 'ar', subGroup: 'fulfill' },
    '/serve/ARServeCookings': { module: 'ar', subGroup: 'fulfill' },
    '/serve/ARServeDeliveries': { module: 'ar', subGroup: 'fulfill' },
    '/serve/ARServeMaterialCountings': { module: 'ar', subGroup: 'fulfill' },
    '/serve/ARServeMaterialIssues': { module: 'ar', subGroup: 'fulfill' },
    '/lg/LGTransports': { module: 'ar', subGroup: 'fulfill' },
    '/lg/LGLogs': { module: 'ar', subGroup: 'fulfill' },

    // AR — crm
    '/crm/CRMLeads': { module: 'ar', subGroup: 'crm' },
    '/crm/CRMTickets': { module: 'ar', subGroup: 'crm' },
    '/crm/CRMCampaigns': { module: 'ar', subGroup: 'crm' },
    '/crm/Customers': { module: 'ar', subGroup: 'crm' },
    '/ar/DepositCards': { module: 'ar', subGroup: 'crm' },
    '/ar/ServiceCards': { module: 'ar', subGroup: 'crm' },
    '/wallet/WalletTrans': { module: 'ar', subGroup: 'crm' },

    // AR — workspace (không có subGroup)
    '/serve/ARServeStatuses': { module: 'ar' },
    '/event/AREventSessionStatuses': { module: 'ar' },
    '/travel/ARTravelSessions': { module: 'ar' },

    // IC
    '/inv/ICInventories': { module: 'ic' },
    '/inv/ICIssues': { module: 'ic' },

    // AP
    '/spc/SPCDemandPlannings': { module: 'ap' },
    '/spc/SPCDemandPurchases': { module: 'ap' },
    '/ap/APRequests': { module: 'ap' },

    // Setting
    '/setting/General': { module: 'setting' },
    '/ai/AIJobQueues': { module: 'setting' },

    // Settings — System subGroup (Hệ thống — luôn cuối tab Settings)
    '/setting/sys':                    { module: 'setting', subGroup: 'setting_system' },
    '/setting/sys/data':               { module: 'setting', subGroup: 'setting_system' },
    '/setting/sys/SysDataAudits':      { module: 'setting', subGroup: 'setting_system' },
    '/setting/sys/SysDataBackups':     { module: 'setting', subGroup: 'setting_system' },
    '/deployment/':                    { module: 'setting', subGroup: 'setting_system' },

    // GL — Hạch toán tự động (PNL items)
    // Đợt 5: Chờ ghi sổ, Hạch toán lại, Lỗi tạo bút toán nằm trong danh sách Phiếu kế toán (/gl/GLJournals).
    '/gl/GLJournals':            { module: 'gl', subGroup: 'gl_posting' },
    '/pnl/PNLLedgerPostings':    { module: 'gl', subGroup: 'gl_posting' },
    '/pnl/PNLJournals':          { module: 'gl', subGroup: 'gl_posting' },
    '/pnl/PNLServeCostings':     { module: 'gl', subGroup: 'gl_posting' },

    // GL — Kế toán (sổ sách)
    // Ẩn GLAccountingPolicy cho tới khi cầu nối kế toán ngoài hoạt động đầy đủ.
    '/gl/GLPostedJournals':   { module: 'gl', subGroup: 'gl_accounting' },
    '/gl/GLPNLCalculates':    { module: 'gl', subGroup: 'gl_accounting' },
    '/gl/GLPeriodClosings':   { module: 'gl', subGroup: 'gl_accounting' },
    '/gl/GLFXRevaluations':   { module: 'gl', subGroup: 'gl_accounting' },
    '/gl/GLServeCostings':    { module: 'gl', subGroup: 'gl_accounting' },
    '/gl/GLMFCostings':       { module: 'gl', subGroup: 'gl_accounting' },

    // GL — Báo cáo tài chính
    '/gl/GLBalanceSheets':         { module: 'gl', subGroup: 'gl_report' },
    '/gl/GLPNLReports':            { module: 'gl', subGroup: 'gl_report' },
    '/gl/GLCashFlowReports':       { module: 'gl', subGroup: 'gl_report' },
    '/gl/GLEquityChanges':         { module: 'gl', subGroup: 'gl_report' },
    '/gl/GLTrialBalances':         { module: 'gl', subGroup: 'gl_report' },
    '/gl/GLGeneralLedgers':        { module: 'gl', subGroup: 'gl_report' },
    '/gl/GLGeneralLedgerDetails':  { module: 'gl', subGroup: 'gl_report' },
    '/gl/GLEntityLedgers':         { module: 'gl', subGroup: 'gl_report' },
    '/gl/GLVATInputReports':       { module: 'gl', subGroup: 'gl_report' },
    '/gl/GLVATOutputReports':      { module: 'gl', subGroup: 'gl_report' },
    '/pnl/PNLMonthlyReports':      { module: 'gl', subGroup: 'gl_report' },

    // Integration provider settings — one page with a tab for each connection type.
    '/integration/providers':                    { module: 'setting', subGroup: 'setting_connection' },

    // Legacy URLs remain in the same Settings group.
    '/integration/providers/salechannel':         { module: 'setting', subGroup: 'setting_connection' },
    '/integration/providers/social':             { module: 'setting', subGroup: 'setting_connection' },
    '/integration/providers/advertising':        { module: 'setting', subGroup: 'setting_connection' },
    '/integration/providers/message':            { module: 'setting', subGroup: 'setting_connection' },
    '/integration/providers/reviews':            { module: 'setting', subGroup: 'setting_connection' },
    '/integration/providers/affiliate':          { module: 'setting', subGroup: 'setting_connection' },
    '/integration/providers/carrier':            { module: 'setting', subGroup: 'setting_connection' },
    '/integration/providers/food':               { module: 'setting', subGroup: 'setting_connection' },

    // Omnichannel — Bán hàng (đơn từ sàn + tương tác sàn)
    '/saleChannel/SaleChannelOrders':            { module: 'omni', subGroup: 'omni_sell' },

    // Module 'connect' — Giám sát/đối soát kết nối với providers (cross-domain).
    // Tab Connect chia theo từng loại kết nối; mỗi loại chỉ có một điểm vào giám sát.
    '/saleChannel/SaleChannelFulfillments':      { module: 'connect', subGroup: 'connect_sale_monitor' },
    '/saleChannel/SaleChannelEvents':            { module: 'connect', subGroup: 'connect_sale_monitor' },
    '/saleChannel/SaleChannelJobQueues':         { module: 'connect', subGroup: 'connect_sale_monitor' },
    '/saleChannel/SaleChannelMonitor':           { module: 'connect', subGroup: 'connect_sale_monitor' },
    '/socialChannel/SocialChannelMonitor':       { module: 'connect', subGroup: 'connect_social_monitor' },
    '/socialChannel/SocialChannelEvents':        { module: 'connect', subGroup: 'connect_social_monitor' },
    '/socialChannel/SocialChannelJobQueues':     { module: 'connect', subGroup: 'connect_social_monitor' },
    '/socialChannel/SocialTemplates':            { module: 'connect', subGroup: 'connect_social_monitor' },
    '/socialChannel/SocialAutoRules':            { module: 'connect', subGroup: 'connect_social_monitor' },
    '/socialChannel/SocialReport':               { module: 'connect', subGroup: 'connect_social_monitor' },
    // Vận hành Email/SMS + Quảng cáo + Đánh giá (group V1 "Vận hành kết nối" → flatten).
    '/marketing/MKGDeliveryLog':                 { module: 'connect', subGroup: 'connect_message' },
    '/marketing/MKGOptOut':                      { module: 'connect', subGroup: 'connect_message' },
    '/marketing/MessageChannelMonitor':          { module: 'connect', subGroup: 'connect_message' },
    '/marketing/MKGConversionEvent':             { module: 'connect', subGroup: 'connect_advertise' },
    '/marketing/AdvertiseChannelMonitor':        { module: 'connect', subGroup: 'connect_advertise' },
    '/marketing/ReviewChannelMonitor':           { module: 'connect', subGroup: 'connect_review' },
    // Affiliate (group V1 "Affiliate" → flatten) → subGroup connect_affiliate.
    '/marketing/MKGAffOffer':                    { module: 'connect', subGroup: 'connect_affiliate' },
    '/marketing/MKGAffPublisher':                { module: 'connect', subGroup: 'connect_affiliate' },
    '/marketing/MKGAffTrackingLink':             { module: 'connect', subGroup: 'connect_affiliate' },
    '/marketing/MKGAffPostback':                 { module: 'connect', subGroup: 'connect_affiliate' },
    '/marketing/AffiliateChannelMonitor':        { module: 'connect', subGroup: 'connect_affiliate' },
    // Vận chuyển (group V1 "Vận chuyển" → flatten) → subGroup connect_carrier.
    '/carrier/INTCarrierOrders':                 { module: 'connect', subGroup: 'connect_carrier' },
    '/carrier/INTCarrierEvents':                 { module: 'connect', subGroup: 'connect_carrier' },
    '/carrier/INTCarrierJobQueues':              { module: 'connect', subGroup: 'connect_carrier' },
    '/carrier/INTCarrierMonitor':                { module: 'connect', subGroup: 'connect_carrier' },
    '/food/FoodDeliveryMonitor':                 { module: 'connect', subGroup: 'connect_food' },
    '/food/INTFoodOrders':                       { module: 'connect', subGroup: 'connect_food' },
    '/food/INTFoodEvents':                       { module: 'connect', subGroup: 'connect_food' },
    '/food/INTFoodJobQueues':                    { module: 'connect', subGroup: 'connect_food' },

    // Omnichannel — Cấu hình (connection — Items tab nằm trong app detail)
    '/saleChannel/SaleChannelApps':       { module: 'omni', subGroup: 'omni_config' },

    // Hội thoại (SocialDesk) — ĐƯA về module Bán hàng (ar/sell), hiển thị ngay TRÊN /integration/Orders
    // (vị trí do thứ tự item trong app-navigation.js quyết định — đã đặt ngay trước "Đơn từ kênh").
    '/socialChannel/Conversations':              { module: 'ar', subGroup: 'sell' },
    '/marketing/MKGReviews':                     { module: 'connect', subGroup: 'connect_review' },

    // Đơn từ kênh (sale + social) GỘP về module Bán hàng (ar) qua màn integration/Orders multi-tab.
    // Legacy routes giữ tạm — sẽ xoá sau khi user verify màn unified.
    '/integration/Orders':                       { module: 'ar', subGroup: 'sell' },
    '/saleChannel/SaleChannelOrders':            { module: 'ar', subGroup: 'sell' },
    '/socialChannel/SocialOrders':               { module: 'ar', subGroup: 'sell' },

    // Social Channel — Cấu hình (connection — Items tab nằm trong app detail)
    '/socialChannel/SocialChannelApps':          { module: 'social', subGroup: 'social_config' }
};

// --- PREFIX_RULES: path prefix → { module } (fallback) ----------------------
// Chỉ gán module; subGroup mặc định undefined (rơi vào section đầu).
// Thứ tự không quan trọng vì tất cả là prefix rời — dùng startsWith, match đầu thắng.
var PREFIX_RULES = [
    ['/home', { module: 'home' }],
    ['/serve/', { module: 'ar' }],
    ['/rental/', { module: 'ar' }],
    ['/event/', { module: 'ar' }],
    ['/travel/', { module: 'ar' }],
    ['/wallet/', { module: 'ar' }],
    ['/loyalty/', { module: 'ar' }],
    ['/crm/', { module: 'ar' }],
    ['/ar/', { module: 'ar' }],
    ['/lg/', { module: 'ar' }],
    ['/ap/', { module: 'ap' }],
    ['/spc/', { module: 'ap' }],
    ['/inv/', { module: 'ic' }],
    ['/ca/', { module: 'ca' }],
    ['/exp/', { module: 'exp' }],
    ['/exr/', { module: 'exp' }],
    ['/sale/', { module: 'exr' }],
    ['/fa/', { module: 'fa' }],
    ['/asset/', { module: 'fa' }],
    ['/tool/', { module: 'fa' }],
    ['/costing/', { module: 'costing' }],
    ['/gl/', { module: 'gl', subGroup: 'gl_accounting' }],
    ['/pnl/', { module: 'gl', subGroup: 'gl_posting' }],
    ['/tax/', { module: 'tax' }],
    ['/pm/', { module: 'pm' }],
    ['/project/', { module: 'pm' }],
    ['/hr/', { module: 'hr' }],
    ['/hrm/', { module: 'hr' }],
    ['/payroll/', { module: 'hr' }],
    ['/pos/HRWorking', { module: 'hr' }],
    ['/mf/', { module: 'mf' }],
    ['/report/', { module: 'report' }],
    ['/rpt/', { module: 'report' }],
    // /setting/sys/* và /deployment/* phải MATCH TRƯỚC /setting/ và /deploy/
    ['/setting/sys/', { module: 'setting', subGroup: 'setting_system' }],
    ['/deployment/', { module: 'setting', subGroup: 'setting_system' }],
    ['/ai/', { module: 'setting' }],
    ['/setting/', { module: 'setting' }],
    ['/user/', { module: 'setting', subGroup: 'setting_permission' }],
    ['/deploy/', { module: 'setting' }],
    ['/b2b/', { module: 'setting' }],
    ['/integration/', { module: 'omni', subGroup: 'omni_config' }]
];

// --- HIDDEN_PATHS: path ẩn hẳn ---------------------------------------------
var HIDDEN_PATHS = {
    '/ar/ARServiceOrders': 1,
    '/ar/ARWarranties': 1,
    '/ar/ARWarrantyClaims': 1,
    '/ar/CustomerAssets': 1,
    '/ar/ARAssetRegistrations': 1,
    '/ar/ARMaintainPlans': 1,
    '/ar/ARMaintainReminders': 1
};

// --- FLATTEN_ANCHORS: nhóm có path anchor trong đây sẽ mở banh trẻ con ra --
var FLATTEN_ANCHORS = {
    '/serve/ARServeServices': 1,
    '/ar/ARServicePlans': 1,
    '/ar/ARIssues': 1,
    '/gl/GLJournals': 1,            // group "Kế toán" v1 (anchor = mục đầu: Phiếu kế toán, đợt 5)
    '/gl/GLBalanceSheets': 1,       // group "Báo cáo tài chính" v1
    '/saleChannel/SaleChannelApps': 1, // group "Sàn TMĐT" v1 → flatten thành 7 items omni_*
    '/socialChannel/SocialChannelApps': 1, // group "Kênh xã hội" v1 → flatten thành 7 items social_*
    // Module 'connect' (Kết nối) — 2 V1 groups split sale/social. Mỗi child item
    // tự resolvePath qua RULES (đã map module='connect' + subGroup 'connect_sale|social_monitor').
    '/saleChannel/SaleChannelMonitor': 1, // group "Theo dõi sàn TMĐT" v1 anchor
    '/socialChannel/SocialChannelMonitor': 1,
    '/marketing/MessageChannelMonitor': 1,
    '/marketing/AffiliateChannelMonitor': 1,
    '/carrier/INTCarrierMonitor': 1,
    '/food/FoodDeliveryMonitor': 1
};

function firstDescendantPath(item) {
    if (!item) return null;
    if (item.path) return item.path;
    if (item.items) {
        for (var i = 0; i < item.items.length; i++) {
            var p = firstDescendantPath(item.items[i]);
            if (p) return p;
        }
    }
    return null;
}

function resolvePath(path) {
    if (!path) return { module: 'setting' };
    if (RULES[path]) return RULES[path];
    for (var i = 0; i < PREFIX_RULES.length; i++) {
        if (path.indexOf(PREFIX_RULES[i][0]) === 0) return PREFIX_RULES[i][1];
    }
    return { module: 'setting' };
}

var navigationV2 = [];
for (var i = 0; i < appNavigation.length; i++) {
    var item = appNavigation[i];
    var anchor = firstDescendantPath(item);

    // Flatten: mở banh trẻ con thành items top-level, mỗi trẻ tự resolve
    if (anchor && FLATTEN_ANCHORS[anchor] && item.items && item.items.length) {
        for (var j = 0; j < item.items.length; j++) {
            var child = item.items[j];
            if (child.path && HIDDEN_PATHS[child.path]) continue;
            navigationV2.push(Object.assign({}, child, child.module ? { module: child.module, subGroup: child.subGroup } : resolvePath(child.path)));
        }
        continue;
    }

    if (anchor && HIDDEN_PATHS[anchor]) continue;
    // Mục khai `module` trực tiếp thì ưu tiên hơn RULES/PREFIX (nhóm Phải thu của gói Kế toán).
    navigationV2.push(Object.assign({}, item, item.module ? { module: item.module, subGroup: item.subGroup } : resolvePath(anchor)));
}

if (process.env.NODE_ENV === 'development') {
    var unmapped = [];
    for (var k = 0; k < appNavigation.length; k++) {
        var a = firstDescendantPath(appNavigation[k]);
        if (a && !RULES[a] && !FLATTEN_ANCHORS[a]) unmapped.push(a);
    }
    if (unmapped.length) {
        // eslint-disable-next-line no-console
        console.info('[nav-v2] Anchor paths using PREFIX_RULES fallback (consider adding to RULES for explicit subGroup):', unmapped);
    }
}

export default navigationV2;
export { appModules };
